import apiClient from "../api/apiClient";

const registerUser = async (userData) => {
  const response = await apiClient.post(`/auth/register`, userData);
  return response.data;
};

const loginUser = async (userData) => {
  const response = await apiClient.post(`/auth/login`, userData);
  return response.data;
};

export const changeAdminPassword = async (data) => {
  const response = await apiClient.patch(`/settings/change-password`, data);
  return response.data;
};


export default { registerUser, loginUser, changeAdminPassword };
